<template>
  <div>

    <div calss="">
      <draggable v-if="checkProperty(tasks, 'length') > 0" class="dragArea" tag="div" :list="tasks"
        :group="{ name: groupName }" @start="showRestore(true)">
        <template v-for="(el, index) in tasks">
          <!-- <template v-if="checkProperty(el, 'isTrashDocument') == isTrashDocument && checkItem(el)"> -->
          <template>
            <div :key="index+ el.name" class="dragArea_list">
              <div class=" d-flex">
                <!-- <p v-if="el.category" style="color: rgb(255, 0, 25);">{{ el.category }}</p> -->
                <!-- {{ el['isSelected'] }} -->
                <vs-checkbox @change="onSelectChange(el, index)" :name="'selecteAll'+index + el.name"
                  v-model="el['isSelected']" class="">
                </vs-checkbox>
                

                <p v-if="el.name"> {{ el.name }}</p>

                <ul class="drag_actions">
                  <li>
                    <span class="doc_delete download" v-if="checkProperty(el, 'path')">
                      <img src="@/assets/images/main/down-arrow2.svg" @click="downloadView(el)" />
                      <em>Download</em>
                    </span>
                  </li>
                  <li v-if="false">
                    <span class="doc_delete" v-if="isTrashDocument">
                      <img src="@/assets/images/main/delete-row-img.svg" @click="moveToTrash(el, false)" />
                      <em>Remove from the Trash</em>
                    </span>
                  </li>
                  <li v-if="false">
                    <span class="doc_delete" v-if="!isTrashDocument">
                      <img src="@/assets/images/main/delete-row-img.svg" @click="moveToTrash(el, true)" />
                      <em>Move to Trash</em>
                    </span>
                  </li>
                  <li>

                  </li>

                </ul>
              </div>
              <nested-draggable class="nestedDrag" :tasks="el.tasks" @updatedSelectedItem="updatedSelectedItem"/>
            </div>
          </template>
        </template>
      </draggable>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";

import * as _ from "lodash";
export default {
  mounted() {
    setTimeout(() => {
      // this.init();
    }, 10000);

  },
  data() {
    return {
      allTasks: [],
      finalSaveItems: [],

    }
  },
  methods: {
    downloadView(value) {
      this.downloads3file(value)
      // this.$emit('download_or_view' ,value);
    },
    downLoadAction() {
      this.finalSaveItems = [];

    },
    moveToTrash(selectedItem, action = false) {
      if (!_.has(selectedItem, "isTrashDocument")) {
        Object(selectedItem, { "isTrashDocument": action });
        selectedItem['isTrashDocument'] = action
      }
      selectedItem['isTrashDocument'] = action

      //isTrashDocument
      if (_.has(selectedItem, 'tasks') && selectedItem['tasks'] && this.checkProperty(selectedItem, 'tasks', 'length') > 0) {
        _.forEach(selectedItem['tasks'], (mTItem) => {
          mTItem['isTrashDocument'] = action
          if (_.has(mTItem, 'tasks') && mTItem['tasks'] && this.checkProperty(mTItem, 'tasks', 'length') > 0) {
            _.forEach(mTItem['tasks'], (sItem) => {
              sItem['isTrashDocument'] = action

              if (_.has(sItem, 'tasks') && sItem['tasks'] && this.checkProperty(sItem, 'tasks', 'length') > 0) {
                _.forEach(sItem['tasks'], (item) => {
                  item['isTrashDocument'] = action
                  if (_.has(item, 'tasks') && item['tasks'] && this.checkProperty(item, 'tasks', 'length') > 0) {
                    _.forEach(item['tasks'], (docItem) => {
                      docItem['isTrashDocument'] = action
                      if (_.has(docItem, 'tasks') && docItem['tasks'] && this.checkProperty(docItem, 'tasks', 'length') > 0) {
                        _.forEach(docItem['tasks'], (lItem) => {
                          lItem['isTrashDocument'] = action
                          if (_.has(lItem, 'tasks') && lItem['tasks'] && this.checkProperty(lItem, 'tasks', 'length') > 0) {
                            _.forEach(lItem['tasks'], (DItem) => {
                              DItem['isTrashDocument'] = action
                            })
                          }

                        })
                      }

                    })
                  }

                })
              }


            })
          }
        })
      }
    },
    remMveFromTrash(item) {
      if (!_.has(item, "isTrashDocument")) {
        Object(item, { "isTrashDocument": false });
        item['isTrashDocument'] = false
      }
      item['isTrashDocument'] = false;
      _.forEach(item['tasks'], (taskItem) => {
        Object(taskItem, { "isTrashDocument": false });
        taskItem['isTrashDocument'] = false;
      });
      //isTrashDocument
    },
    showRestore(action = false) {
      this.$store.commit('isDraggeded', action);
    },

    onSelectChange(selectedItem, aAction = false,index) {
      setTimeout(()=>{
      //   alert(selectedItem.isSelected)
      // let action = selectedItem.isSelected?false:true
      // if (!_.has(selectedItem, "isSelected")) {
      //   Object(selectedItem, { "isSelected": action });
      //   selectedItem['isSelected'] = action
      // }
      // selectedItem['isSelected'] = action

      // //isTrashDocument
      // if (_.has(selectedItem, 'tasks') && selectedItem['tasks'] && this.checkProperty(selectedItem, 'tasks', 'length') > 0) {
      //   _.forEach(selectedItem['tasks'], (mTItem) => {
      //     mTItem['isSelected'] = action
      //     if (_.has(mTItem, 'tasks') && mTItem['tasks'] && this.checkProperty(mTItem, 'tasks', 'length') > 0) {
      //       _.forEach(mTItem['tasks'], (sItem) => {
      //         sItem['isSelected'] = action

      //         if (_.has(sItem, 'tasks') && sItem['tasks'] && this.checkProperty(sItem, 'tasks', 'length') > 0) {
      //           _.forEach(sItem['tasks'], (item) => {
      //             item['isSelected'] = action
      //             if (_.has(item, 'tasks') && item['tasks'] && this.checkProperty(item, 'tasks', 'length') > 0) {
      //               _.forEach(item['tasks'], (docItem) => {
      //                 docItem['isSelected'] = action
      //                 if (_.has(docItem, 'tasks') && docItem['tasks'] && this.checkProperty(docItem, 'tasks', 'length') > 0) {
      //                   _.forEach(docItem['tasks'], (lItem) => {
      //                     lItem['isSelected'] = action
      //                     if (_.has(lItem, 'tasks') && lItem['tasks'] && this.checkProperty(lItem, 'tasks', 'length') > 0) {
      //                       _.forEach(lItem['tasks'], (DItem) => {
      //                         DItem['isSelected'] = action
      //                       })
      //                     }

      //                   })
      //                 }

      //               })
      //             }

      //           })
      //         }


      //       })
      //     }
      //   })
      // }
      // this.tasks[index]=selectedItem
      // //this.tasks =_.cloneDeep(this.tasks);
      
      

      this.$emit('updatedSelectedItem' ,selectedItem);

    },10)

    },
    updatedSelectedItem(selectedItem){
      this.$emit('updatedSelectedItem' ,selectedItem);
    },
    debouncedSelectChange: _.debounce(function (el, index) {
      this.onSelectChange(el, index);
      // this.$emit('updatedSelectedItem' ,selectedItem);
    }, 10),



  },
  props: {

    groupName: {
      type: String,
      default: 'g1'
    },
    isTrashDocument: {
      type: Boolean,
      default: false
    },
    petitionDetails: {
      type: Object,
      default: null,
    },
    tasks: {
      required: true,
      type: Array
    }
  },
  components: {
    VuePerfectScrollbar,
    draggable
  },
  computed: {
    checkItem() {
      return (item) => {
        if (this.checkProperty(item, "path")) {
          return true
        } else if (this.checkProperty(item, "tasks", 'length') > 0) {
          let activeItems = _.filter(item['tasks'], { "isTrashDocument": false })
          if (activeItems.length > 0) {
            return true
          } else {
            return false;
          }

        } else {
          return false;
        }

      }
    },

  },
  name: "nested-draggable"
};
</script>
<style scoped>
.dragArea {
  /* min-height: 15px;
  outline: 1px dashed; */
  margin-top: 2px;
  margin-bottom: 2px;
}

/* .nestedDrag{
    padding-left: 20px;
} */
</style>